import React from 'react';
import './MonthlySummary.css';

const MonthlySummary = ({ data, loading }) => {
  if (loading) {
    return <div className="chart-loading">Loading monthly summary...</div>;
  }

  if (!data || !data.months || data.months.length === 0) {
    return <div className="chart-empty">No monthly data available</div>;
  }

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR',
    }).format(value);
  };

  const formatMonth = (monthStr) => {
    const [year, month] = monthStr.split('-');
    const date = new Date(parseInt(year), parseInt(month) - 1, 1);
    return date.toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' });
  };

  return (
    <div className="monthly-summary">
      <h3 className="chart-title">Monthly Summary</h3>
      
      <div className="summary-overview">
        <div className="overview-card">
          <span className="overview-label">Total Income</span>
          <span className="overview-value income">{formatCurrency(data.total_income)}</span>
        </div>
        <div className="overview-card">
          <span className="overview-label">Total Expenses</span>
          <span className="overview-value expense">{formatCurrency(data.total_expenses)}</span>
        </div>
        <div className="overview-card">
          <span className="overview-label">Net Total</span>
          <span className={`overview-value ${data.total_net >= 0 ? 'income' : 'expense'}`}>
            {formatCurrency(data.total_net)}
          </span>
        </div>
      </div>

      <div className="monthly-table">
        <table>
          <thead>
            <tr>
              <th>Month</th>
              <th>Income</th>
              <th>Expenses</th>
              <th>Net</th>
              <th>Transactions</th>
            </tr>
          </thead>
          <tbody>
            {data.months.map((month, index) => (
              <tr key={index}>
                <td className="month-name">{formatMonth(month.month)}</td>
                <td className="amount income">{formatCurrency(month.income)}</td>
                <td className="amount expense">{formatCurrency(month.expenses)}</td>
                <td className={`amount ${month.net >= 0 ? 'income' : 'expense'}`}>
                  {formatCurrency(month.net)}
                </td>
                <td className="transactions-count">{month.transactions_count}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MonthlySummary;
